export enum VideoSource {
	Mux = "Mux",
	Youtube = "Youtube",
	Vimeo = "Vimeo",
}